import React, { useEffect, useState , useRef, useLayoutEffect } from 'react';
import { useChatboxDispatchContext, useChatboxStateContext } from '../../context/ChatboxContext';
import ConversationAction from '../../actions/ConversationAction';
import { useConversationStateContext } from '../../context/ConversationContext';
import UploadFile from 'jsx:../../assets/upload-file.svg';

function ChatboxFooter() {

    const [ inputValue, setInputValue ] = useState("");
    const dispatch = useChatboxDispatchContext();
    const { data } = useConversationStateContext();
    const { askBotNextQuestion } = ConversationAction();

    const { canSendDataToServer ,valueOpen} = useChatboxStateContext();
    const {chatboxColor} = useConversationStateContext();
    const { responses } = data;
    const inputRef = useRef(null); 
    const [focusInput,setFocusInput] = useState(false);
    
    const response = responses.filter(response => response.type == 'custom' || response.content?.context == 'upload_file_action').pop();
    const type = response?.content?.context == "upload_file_action" ? "file" : "text"
    const isInputValid = response ? canSendDataToServer : null;
    
    const sendData = () => {
        if (response == null) return;
        if (response.type== "custom" && inputValue.trim() == ""){
            return;
        }
        askBotNextQuestion(response.tracking, inputValue)
        setInputValue("");
        setFocusInput(!focusInput)
    }

    const onChange = ({target : { value, files }}) => {
        const input = files ? files[0] : value.replace(/[{}[\]()#$&%*:;!\\^~|"]/g, '');
        setInputValue(input);
    }

    const onKeyDown = (event) => {
        if(event.key !== "Enter") {
            return null
        }

        sendData();
    }

    useEffect(() => {
        inputRef.current.focus();
    }, [valueOpen]);

    useEffect(()=>{
        if(focusInput){
            inputRef.current.focus();
        }
      
    },[focusInput])

    var placeholder = ''
    if(response?.content){
        placeholder = response.content == 'Custom Response' ? 'Tapez votre message' : (response.content?.values?.text ? response.content?.values?.text : response.content);
    }

    return (
        <div className='kwalys-bottom' style={{background:chatboxColor}}>
            {type == 'file' ? <label htmlFor="kwalys-input" className='kwalys-input-label'><UploadFile/>{placeholder}{inputValue ? ` : ${inputValue.name}` : ''}</label> : ''}
            <input type={type} id="kwalys-input" autoComplete="off" value={type == 'text' ? inputValue : ''} placeholder={placeholder} {...(response ? { tracking : response.tracking } : {})} onChange={onChange} disabled={isInputValid === undefined} onKeyDown={onKeyDown}  ref={inputRef} style={{...(type == 'file' ? { display : 'none' } : {})}}/>
            <button id="kwalys-send" disabled={response ? (!inputValue ? true : false ): true}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" onClick={sendData}>
                    <path id="send-svg" d="M19.18.106L.533 9.336c-.756.375-.701.84.124 1.036l5.752 1.358 3.157 4.822c.133.203.336.32.557.323h.008a.678.678 0 0 0 .556-.31l2.271-3.289 4.1.968a.612.612 0 0 0 .464-.079.58.58 0 0 0 .255-.386L19.984.681c.098-.584-.264-.843-.804-.575zM9.83 11.894l-.002.004-.008.013c-.007.009-.012.019-.018.03l-.014.022a.072.072 0 0 0-.005.012c-.005.01-.008.02-.012.031l-.01.03-.001.004-.001.007-.005.03-.004.032v.015l-.001.006.01 3.21L7.2 11.379l9.6-8.31-6.97 8.826z"></path>
                </svg>
            </button>
        </div>

    );
}

export default ChatboxFooter;